











import { Component, Vue } from 'vue-property-decorator'

import 'animate.css/source/_base.css'
import 'animate.css/source/fading_entrances/fadeIn.css'

import Navigation from '@/comps/Navigation.vue'
import Tail from '@/comps/Tail.vue'
import Loader from '@/comps/Loader.vue'

@Component({ components: { Navigation, Tail, Loader } })
export default class App extends Vue {
  loading = true
  mounted () {
    this.loading = false
  }
}
